/**
 * Canonical DOM anchor id for a news-post card (MWBI-935).
 *
 * The post-comment and group-activity emails build their deep-link fragment
 * with `encodeURIComponent(postDocumentId)` (see cms/server/src/api/email/
 * templates/links.ts::groupPostUrl and ::postUrl). The rendered element id,
 * the card's hash comparison, and GroupPostsTab's `getElementById` lookup must
 * all use the SAME encoded form -- otherwise a documentId containing a reserved
 * character (`?`, `#`, `/`, space) would render as `post-<raw>` while the URL
 * hash is `#post-<encoded>`, the two would never match, and the deep link would
 * silently no-op.
 *
 * NewsCard previously rendered the raw `post-${documentId}` while the email
 * already encoded it, so this helper closes an existing asymmetry rather than
 * merely guarding a future one. Strapi documentIds are lowercase alphanumeric
 * today (so the encoding is effectively a no-op), but keeping the frontend
 * symmetric with the backend contract is defense-in-depth against id drift.
 *
 * Mirrors `frontend/src/components/group-tabs/forumAnchor.ts`, the established
 * reference for this pattern.
 */
export function postAnchorId(documentId: string): string {
  return `post-${encodeURIComponent(documentId)}`;
}
